
import Vue from "vue";
import { fetchWithBackoff } from "../../utils/fetchWithBackoff";

const DeviceManagerAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED DEVICE MANAGER API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async fetchSignedUrl(fileName) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages-url`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fileName }),
    });

    return fetchWithBackoff(request);
  }

  async postPackageWithSignedUrl(file, url, filename = "edge_package.zip", version) {
    const formData = new FormData();
    formData.append("file", file, { filename });

    return fetch(url, {
      method: "PUT",
      body: file,
    });
  }

  async postPackage(payload) {
    if (!payload || !payload.signedUrl || !payload.label || !payload.version) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      body: JSON.stringify(payload),
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async postPackageDetails(payload) {
    if (!payload ) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/package-details`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      body: JSON.stringify(payload),
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getPackageDetails(query){
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/package-details?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getPackages(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getPackageVersions(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages/versions?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

 async updatePackageArchiveStatus(payload) {
  if (!payload || !payload.packageId) return;

  const claims = await this.$auth.getIdTokenClaims();
  const id_token = claims && claims.__raw;
  if (!id_token) return;

  const url = `${config.API_GATEWAY_APIGEE}/bed-manager/packages/archive`;
  const request = new Request(url, {
    method: "POST",
    mode: "cors",
    cache: "default",
    body: JSON.stringify(payload),
    headers: {
      Authorization: "Bearer " + id_token,
      "Content-Type": "application/json",
    },
  });

  return fetchWithBackoff(request);
}

  async getDevicesByStatusAndTenant(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/devices-status?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async postJobs(payload) {
    if (!payload) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/jobs`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      body: JSON.stringify(payload),
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async filterJobDevices(payload) {
    if (!payload) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/jobs/filter-devices`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      body: JSON.stringify(payload),
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async cancelJobDeviceTask(payload) {
    if (!payload || !payload.tenant || !payload.jobId || !payload.batchJobId || !payload.deviceId || !payload.taskId) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/jobs/cancel`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      body: JSON.stringify(payload),
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async cancelJobRequest(payload) {
    if (!payload || !payload.tenant || !payload.requestId) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/jobs/cancel-request`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      body: JSON.stringify(payload),
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async markBedsNotified(payload) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/devices-status/notified`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      body: JSON.stringify(payload),
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getJobs(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;
    if (!query.scope) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/jobs?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getConfiguration() {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/configuration`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getComponentAndVersions(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;
    if (!query.scope) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/component-versions?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  // New: call server-side CreateJobs devices endpoint
  async getCreateJobsDevices(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;
    if (!query || !query.scope) return;

    // Only include limit if provided by client — server returns all when limit omitted
    const qs = new URLSearchParams();
    Object.keys(query).forEach(k => {
      const v = query[k];
      if (v === undefined || v === null || v === '') return;
      // preserve components object/string as-is
      qs.append(k, v);
    });

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/devices/create-jobs?${qs.toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getCompactDeviceAttribute(query) {
    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;
    if (!query.scope) return;

    const url = `${config.API_GATEWAY_APIGEE}/bed-manager/devices/compact-attributes?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$DeviceManagerAPIService) {
  Vue.prototype.$DeviceManagerAPIService = new DeviceManagerAPIService();
}

export default Vue.prototype.$DeviceManagerAPIService;
